<template>
  <List :mapState="'inventoryProductsCategories'" :allDispatch="'inventoryProductsCategoriesAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/inventory/products/categories/list.vue